/**
 * The column template for the focus card, shared by its header and every row --
 * one literal string for the reason dayGrid.ts and taskGrid.ts give: Tailwind
 * scans source text and would never generate a template composed at runtime.
 *
 * Columns: done toggle | title | project | tracked | row actions.
 *
 * Narrower than DAY_GRID by two whole columns, and that is the point. The day
 * list is a list you triage -- status, due date and priority are the three
 * things you sort it by. This one is four tasks you already chose; the
 * decisions are made, and re-displaying the inputs to a decision you have taken
 * is noise. What is left is what changes while you work: is it done, and how
 * long have you been on it.
 *
 * The leading track is 1rem at every width rather than DAY_GRID's 5.25rem: the
 * status here is a tick box, not a StatusCell. Everything past "done or not" is
 * one click away in the panel, and a session that needed a status menu on every
 * row would be a task list with extra steps.
 *
 * The trailing track is 2.75rem, the same two-button width both other templates
 * use -- here the timer and the put-back.
 */
export const FOCUS_GRID =
  'grid items-center gap-x-3 grid-cols-[1rem_minmax(0,1fr)_3.5rem_2.75rem] sm:grid-cols-[1rem_minmax(0,1fr)_7rem_3.5rem_2.75rem]';
